import { useEffect, useRef, useState } from 'react';
import './PromoVideo.css';

/**
 * Landscape promo clip that plays silently on loop while it is on screen
 * and pauses when scrolled away. Visitors who prefer reduced motion get a
 * poster with normal controls instead of autoplay.
 */
export default function PromoVideo({ src, poster, title }) {
  const ref = useRef(null);
  const [reduceMotion] = useState(
    () => typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  );

  useEffect(() => {
    const video = ref.current;
    if (!video || reduceMotion || !('IntersectionObserver' in window)) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.35 }
    );
    observer.observe(video);
    return () => observer.disconnect();
  }, [reduceMotion]);

  return (
    <div className="promo-video">
      <video
        ref={ref}
        src={src}
        poster={poster}
        muted
        loop
        playsInline
        preload={reduceMotion ? 'none' : 'metadata'}
        controls={reduceMotion}
        aria-label={title}
        title={title}
        width={1920}
        height={1080}
      />
    </div>
  );
}
